import base from './base'; //base urls list
import axios from '../https';//axios instance
const env = base.backend
const bo_api = { 
    // get all the smsf of this user   
    bo_values(brand){   
        return axios.get(`${env}/api/smsf/${brand}/retrieve_bo_values/`);    
    },    
    basic_info(brand){
        return axios.get(`${env}/api/smsf/${brand}/retrieve_basic_info/`);    
    },
    contributions(brand){
        return axios.get(`${env}/api/contribution/${brand}/retrieve_bo/`);    
    },
    insurance(brand){
        return axios.get(`${env}/api/trustee/${brand}/retrieve_bo/`);    
    },
    pension(brand){
        return axios.get(`${env}/api/pension/${brand}/retrieve_bo/`);    
    },
    investments(brand){
        return axios.get(`${env}/api/investment/${brand}/retrieve_bo/`);    

    },
    get_outstanding_queries_sum(){
        return axios.get(`${env}/api/header/get_outstanding_queries_sum/`);    
    }
    // .....
}

export default bo_api;